import { FetchFailureAction, FetchRequestAction, FetchSuccessAction, StrapiActionTypes, StrapiItem } from "../../types/strapiGOS";

export const fetchData = (modelName: string, filters?: any, pagination?: { page: number; pageSize: number }, append?: boolean): FetchRequestAction => {
  let params: Record<string, any> = {};

  if (pagination) {
    params['pagination[page]'] = pagination.page;
    params['pagination[pageSize]'] = pagination.pageSize;
  }

  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (key.startsWith('filters[')) {
        params[key] = value;
      } else {
        params[`filters[${key}]`] = value;
      }
    });
  }

  return {
    type: StrapiActionTypes.FETCH_REQUEST_GOS,
    payload: {
      modelName,
      params,
      pagination,
      append,
    },
  };
};

export const fetchDataSuccessGOS = (
  modelName: string,
  data: StrapiItem[],
  pagination?: {
    page: number;
    pageSize: number;
    pageCount: number;
    total: number;
  },
  append?: boolean
): FetchSuccessAction => ({
  type: StrapiActionTypes.FETCH_SUCCESS_GOS,
  payload: {
    modelName,
    data,
    pagination,
    append,
  },
});

export const fetchDataFailureGOS = (modelName: string, error: string): FetchFailureAction => ({
  type: StrapiActionTypes.FETCH_FAILURE_GOS,
  payload: {
    modelName,
    error,
  },
});
